<template>
  <div class="authenticate-other">
    <a-form
      class="mod-form form-other"
      layout="horizontal"
      labelAlign="left"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      :colon="false"
      :form="form"
      @submit="onSubmit"
    >
      <a-form-item label="姓名">
        <a-input
          size="large"
          placeholder="请输入姓名"
          v-decorator="[
            'name',
            {
              initialValue: userInfo.fullName,
              rules: [
                {
                  validator: handleFieldValidate
                }
              ],
              validateTrigger: 'blur'
            }
          ]"
          disabled
        >
        </a-input>
      </a-form-item>
      <a-form-item label="证件类型">
        <a-select
          size="large"
          placeholder="请选择证件类型"
          v-decorator="[
            'certType',
            {
              initialValue: 5,
              rules: [
                {
                  validator: handleFieldValidate
                }
              ],
              validateTrigger: 'blur'
            }
          ]"
          @change="idTypeChange"
        >
          <a-select-option :value="5">身份证（仅限2-12周岁儿童旅客）</a-select-option>
          <a-select-option :value="2">护照</a-select-option>
          <a-select-option :value="207">港澳台居民居住证</a-select-option>
          <a-select-option :value="15">港澳居民来往内地通行证</a-select-option>
          <a-select-option :value="206">台湾居民来往大陆通行证</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="证件号码">
        <a-input
          size="large"
          placeholder="请输入申请认证的证件号码"
          v-decorator="[
            'idCard',
            {
              rules: [
                {
                  validator: handleFieldValidate
                }
              ],
              validateTrigger: 'blur'
            }
          ]"
          :disabled="disabled"
        >
        </a-input>
      </a-form-item>
      <a-form-item label="手机号码">
        <a-input
          size="large"
          placeholder="请输入手机号码"
          v-decorator="[
            'mobile',
            {
              initialValue: userInfo.phone,
              rules: [
                {
                  validator: handleFieldValidate
                }
              ],
              validateTrigger: 'blur'
            }
          ]"
        >
        </a-input>
      </a-form-item>
      <a-form-item label="邮箱">
        <a-input
          size="large"
          placeholder="请输入邮箱"
          v-decorator="[
            'email',
            {
              rules: [
                {
                  validator: handleFieldValidate
                }
              ],
              validateTrigger: 'blur'
            }
          ]"
        >
        </a-input>
      </a-form-item>
      <a-form-item label="上传附件">
        <p class="upload-tips">（上限6个，每个附件大小不超过5M，仅支持png、jpg、jpeg格式）</p>
        <div class="file-upload-trigger clearfix">
          <a-upload
            :file-list="fileList"
            :customRequest="handleUpload"
            list-type="picture-card"
            name="filename"
            accept=".png, .jpg, .jpeg"
            :headers="{
              token
            }"
            :transformFile="handleTransformFile"
            :beforeUpload="handleBeforeUpload"
            :locale="{
              removeFile: '删除',
              previewFile: '预览'
            }"
            @preview="handlePreview"
            @change="handleUploadChange"
          >
            <div v-if="fileList.length < fileLimit">
              <a-icon type="plus" />
            </div>
          </a-upload>
          <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancelPreview">
            <img alt="example" style="width: 100%" :src="previewImage" />
          </a-modal>
        </div>
      </a-form-item>
      <a-form-item :wrapper-col="wrapperColOffset">
        <a-button style="margin-right: 20px;" size="large" @click="onBack">返回</a-button>
        <a-button type="primary" size="large" :loading="loading" html-type="submit">提交</a-button>
      </a-form-item>
    </a-form>
    <div class="mod-tip other-tip">
      <h4>温馨提示</h4>
      <p class="dot"><span>中国大陆儿童旅客(年龄为2-12周岁) 认证：</span>请上传身份证正面及反面照片、手持证件照片；</p>
      <p><span>港澳台地区及外籍旅客认证：</span>请上传包含身份信息的证件照片、手持证件照片、本人开户的银行卡照片。</p>
      <p class="dot">申请认证上传的证件必须是会员档案中已有证件，如缺少相关证件，请先往账户管理-证件信息中添加。</p>
      <p class="dot">请确保会员档案姓名与证件姓名一致，如会员档案姓名有误，请联系会员服务热线{{ app.hotline }}处理。</p>
      <p class="dot">上传证件材料实名认证将收集您的姓名、证件信息及相关证明材料进行人工审核，预计需要3-5个工作日，审核结果会以短信或邮件形式发送至预留联系方式，请您持续关注。</p>
      <p class="dot">如需任何帮助，请致电{{ app.name }}24小时服务热线{{ app.hotline }}。</p>
    </div>
  </div>
</template>

<script>
import { find } from 'lodash'
import moment from 'moment'
import fromApp from '@/utils/from'
import { validate } from '@/utils/validate'
import { submitProfessional, uploadProfessionalFile } from '@/api/member'
import { verify } from '@/api/verify'
import imageCompression from 'browser-image-compression'

// 图片压缩
const compressImage = async (file) => {
  let compressedFile = null
  const options = {
    maxSizeMB: 1,
    maxWidthOrHeight: 1920,
    useWebWorker: false
  }
  try {
    compressedFile = await imageCompression(file, options)
  } catch (error) {
    compressedFile = null
    console.log('图片压缩失败 >>>> ', error)
  }

  return compressedFile
}

function getBase64 (file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  }).catch((err) => {
    console.error(err)
  })
}

export default {
  props: {
    userInfo: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      labelCol: {
        span: 6
      },
      wrapperCol: {
        span: 18
      },
      wrapperColOffset: {
        offset: 6,
        span: 18
      },
      form: this.$form.createForm(this),
      loading: false,
      phone: '',
      code: '',
      errCode: '',
      fileList: [],
      fileLimit: 6,
      previewVisible: false,
      previewImage: '',
      token: this.$ls.get('USER_CENTER_TOKEN'),
      app: fromApp(),
      disabled: false
    }
  },
  created () {
    this.$nextTick(() => {
      const certType = this.form.getFieldValue('certType')
      const item = find(this.userInfo.userCerts, { certType })

      if (item) {
        this.form.setFieldsValue({
          idCard: item.certNo
        })
        this.disabled = true
      }
    })
  },
  methods: {
    idTypeChange (value) {
      const item = find(this.userInfo.userCerts, { certType: value })
      let idCard = ''
      if (item && item.certNo) {
        idCard = item.certNo
        this.disabled = true
      } else {
        this.disabled = false
      }

      this.form.setFieldsValue({ idCard })
    },
    async onVerify (value, certType, cb) {
      try {
        await verify({
          type: 33,
          certType,
          value
        })

        cb()
      } catch (err) {
        cb(err.message)
      }
    },
    isChd (idCard) {
      const birthFormat = moment(this.fillBirthday(idCard, true), 'YYYY-MM-DD')
      const currentFormat = moment(new Date(), 'YYYY-MM-DD')
      const diffYears = currentFormat.diff(birthFormat, 'years')
      return diffYears >= 2 && diffYears <= 12
    },
    /**
     * 根据身份证号获取生日
     */
    fillBirthday (idCard, isReturn = false) {
      let birth = ''
      if (idCard.length === 15) {
        birth = idCard.slice(6, 12)
        birth = '19' + birth
      } else if (idCard.length === 18) {
        birth = idCard.slice(6, 14)
      }
      const birthday = birth.slice(0, 4) + '-' + birth.slice(4, 6) + '-' + birth.slice(6, 8)
      const birthFormat = moment(birthday, 'YYYY-MM-DD')
      if (!isReturn) {
        this.form.setFieldsValue({
          birthday: birthFormat
        })
      } else {
        return birthday
      }
    },
    handleFieldValidate (rule, value, callback) {
      const certType = this.form.getFieldValue('certType')
      const data = {
        ...this.form.getFieldsValue(),
        certType: String(certType)
      }

      validate('authenticate-other', data, rule.fullField).then(({ valid, error }) => {
        if (valid) {
          if (rule.fullField === 'idCard') {
            if (certType === 5 && !this.isChd(value)) {
              this.$message.error('仅限2-12周岁儿童旅客')
              return
            }

            return this.onVerify(value, certType, callback)
          }

          callback()
        } else {
          callback(error)
        }
      })
    },
    onSubmit (e) {
      e.preventDefault()

      this.form.validateFields(async (errors, values) => {
        if (!errors) {
          if (this.fileList.length <= 0) {
            this.$message.error('请上传附件！')
            return
          }
          const { email, mobile, idCard, certType } = values
          const { chiSurname, chiName, engName, engSurname } = this.userInfo
          // 拼接上传的附件
          const certs = this.fileList.map(({ response }) => {
            if (response && response.length) {
              const { path, url, bucketName } = response[0]
              return { path, url, bucketName }
            } else {
              return null
            }
          }).filter(item => item)

          const params = {
            engName,
            engSurname,
            email,
            mobile,
            idType: certType,
            idCard,
            type: -1,
            authInfo: {
              certs
            }
          }
          if (chiSurname) {
            params.surname = chiSurname
          }

          if (chiName) {
            params.name = chiName
          }

          try {
            this.loading = true
            await submitProfessional(params)
            this.loading = false
            const { name, hotline } = this.app

            this.$info({
              title: '提交成功',
              content: `您的实名认证申请已提交，人工审核预计需要35个工作日，审核结果会以短信或邮件的形式发送至预留联系方式，请您持续关注。如需帮助请联系${name}24小时票服务热线${hotline}。`,
              okText: '确定',
              onOk: () => {
                history.go(-1)
              }
            })
          } catch (err) {
            this.$error({
              content: err.message,
              centered: true
            })

            this.loading = false
            if (err.code.toString().includes(1000)) {
              this.errCode = err.code
            }
          }
        }
      })
    },
    onBack () {
      this.form.resetFields()
      this.$emit('back')
    },
    handleCancelPreview () {
      this.previewVisible = false
    },
    async handlePreview (file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },
    handleUploadChange ({ fileList }) {
      this.fileList = fileList.filter(file => {
        return file.size <= 1024 * 1024 * 5
      })
    },
    handleBeforeUpload (file) {
      // 限制上传超过 5M 的图片
      if (file.size > 1024 * 1024 * 5) {
        this.$message.error('上传的附件大小不能超过5M！')
        return false
      }

      // 有些移动设备的浏览器/APP能够上传其他类型的文件，限制只能上传图片
      if (!/(.jpg|.jpeg|.png)$/g.test(file.name)) {
        this.$message.error('仅支持上传图片的类型：".png", ".jpg", ".jpeg"！')
        return false
      }

      return true
    },
    async handleTransformFile (file) {
      // 图片压缩
      const compressedFile = await compressImage(file)
      return compressedFile || file
    },
    async handleUpload (options) {
      try {
        const params = new FormData()
        params.append('filename', options.file, options.file.name)
        const data = await uploadProfessionalFile(params)
        options.onSuccess(data, options)
      } catch (error) {
        this.$message.error(error.message)
      }
    }
  }
}
</script>
